(function () {
  const csPdpGallerySelectors = {
    viewport: '[data-cs-pdp-gallery-viewport]',
    dots: '[data-cs-pdp-gallery-dots]',
    thumb: '[data-cs-pdp-gallery-thumb]',
    previous: '[data-cs-pdp-gallery-previous]',
    next: '[data-cs-pdp-gallery-next]',
    zoom: '[data-cs-pdp-gallery-zoom]',
    lightbox: '[data-cs-pdp-gallery-lightbox]',
    lightboxImage: '[data-cs-pdp-gallery-lightbox-image]',
    lightboxClose: '[data-cs-pdp-gallery-lightbox-close]',
    overlay: '.cs-pdp-gallery__overlay'
  }

  class CsPdpGallery extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController()
      const signal = this.abortController.signal

      this.viewport = this.querySelector(csPdpGallerySelectors.viewport)
      this.dots = this.querySelector(csPdpGallerySelectors.dots)
      this.thumbs = Array.from(this.querySelectorAll(csPdpGallerySelectors.thumb))
      this.previousButton = this.querySelector(csPdpGallerySelectors.previous)
      this.nextButton = this.querySelector(csPdpGallerySelectors.next)
      this.zoomButton = this.querySelector(csPdpGallerySelectors.zoom)
      this.lightbox = this.querySelector(csPdpGallerySelectors.lightbox)
      this.lightboxImage = this.querySelector(csPdpGallerySelectors.lightboxImage)
      this.lightboxCloseButton = this.querySelector(csPdpGallerySelectors.lightboxClose)
      this.overlay = this.querySelector(csPdpGallerySelectors.overlay)

      this._initSwiper()

      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this._slideTo(index), { signal })
      })

      if (this.previousButton) {
        this.previousButton.addEventListener('click', () => this.swiper && this.swiper.slidePrev(), { signal })
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.swiper && this.swiper.slideNext(), { signal })
      }

      if (this.zoomButton && this.lightbox) {
        this.zoomButton.addEventListener('click', () => this._openLightbox(), { signal })
      }

      if (this.lightboxCloseButton && this.lightbox) {
        this.lightboxCloseButton.addEventListener('click', () => this.lightbox.close(), { signal })
      }
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort()
      if (this.swiper) this.swiper.destroy(true, true)
    }

    _initSwiper() {
      if (!this.viewport || typeof Swiper === 'undefined') return

      this.swiper = new Swiper(this.viewport, {
        slidesPerView: 'auto',
        spaceBetween: 9,
        watchOverflow: true,
        pagination: this.dots ? { el: this.dots, clickable: true } : false,
        breakpoints: {
          901: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        on: {
          slideChange: () => this._syncThumbs()
        }
      })

      this._syncThumbs()
    }

    _slideTo(index) {
      if (!this.swiper) return
      this.swiper.slideTo(index)
    }

    _syncThumbs() {
      const active = this.swiper ? this.swiper.activeIndex : 0
      this.thumbs.forEach((thumb, index) => {
        thumb.setAttribute('aria-current', index === active ? 'true' : 'false')
      })
      if (this.previousButton) this.previousButton.disabled = !!this.swiper && this.swiper.isBeginning
      if (this.nextButton) this.nextButton.disabled = !!this.swiper && this.swiper.isEnd
      if (this.overlay) {
        this.overlay.style.opacity = active === 0 ? '1' : '0'
        this.overlay.style.pointerEvents = active === 0 ? 'none' : 'none'
      }
    }

    _openLightbox() {
      const activeSlide = this.querySelector('.swiper-slide-active') || this.querySelector('.swiper-slide')
      const image = activeSlide && activeSlide.querySelector('img')
      if (image && this.lightboxImage) {
        this.lightboxImage.src = image.currentSrc || image.src
        this.lightboxImage.alt = image.alt
      }
      this.lightbox.showModal()
    }
  }

  if (!customElements.get('cs-pdp-gallery')) {
    customElements.define('cs-pdp-gallery', CsPdpGallery)
  }
})()
